<template>
  <OrqNavbar>
    <OrqFlex gap="16" align-items="center">
      <a href="/" title="ir a Inicio">
        <OrqLogo inverse gap="16" />
      </a>
    </OrqFlex>
  </OrqNavbar>
</template>


<script setup>
  import { OrqNavbar, OrqFlex, OrqLogo } from '@digital/orquestra';
</script>
